// sliders.js
/**
 * This module initializes all the sliders present on the website.
 * Using Swiper library: http://idangero.us/swiper/
 */

// Swiper imports
import Swiper, { Pagination, Navigation, Autoplay, Thumbs } from 'swiper';
Swiper.use([Pagination, Navigation, Autoplay, Thumbs]);
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import 'swiper/css/thumbs';

// Get all slider instances in the DOM
const sliders = document.querySelectorAll('[data-slideshow]');

/**
 * Initialize all sliders
 */
function initSliders() {
    if (!sliders.length) return;

    sliders.forEach(slider => {
        new Swiper(slider, {
            direction: 'horizontal',
            loop: false,
            autoplay: {
                delay: 5000,
            },
            pagination: {
                el: slider.querySelector('.swiper-pagination'),
                type: 'bullets',
                clickable: true,
            },
            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
            },
        });
    });
}

// Initialize on module load
if (sliders.length) {
    initSliders();
}

// Thumbs sliders (product carousel)
const thumbsSliders = document.querySelectorAll('[data-slideshow-thumbs]');

function initThumbsSliders() {
    if (!thumbsSliders.length) return;

    thumbsSliders.forEach(container => {
        const mainEl = container.querySelector('[data-slideshow-main]');
        const thumbsEl = container.querySelector('[data-slideshow-thumb]');

        const thumbsSwiper = new Swiper(thumbsEl, {
            direction: 'horizontal',
            spaceBetween: 12,
            slidesPerView: 4,
            watchSlidesProgress: true,
        });

        new Swiper(mainEl, {
            direction: 'horizontal',
            loop: false,
            pagination: {
                el: mainEl.querySelector('.swiper-pagination'),
                type: 'bullets',
                clickable: true,
            },
            thumbs: {
                swiper: thumbsSwiper,
            },
        });
    });
}

if (thumbsSliders.length) {
    initThumbsSliders();
}